import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { ContractorsApi } from '@/api/domains/contractors.api';
import type { FetchContractorContactsParams } from '@/api/domains/contractors.api';
import { ContractorsQueryKeys } from '@/api/domains/contractors.query-keys';

type UseDistributorContacts = {
  params: Partial<FetchContractorContactsParams>;
  queryOptions?: Pick<UseQueryOptions, 'enabled'>;
};

export const useDistributorContacts = ({ params, queryOptions }: UseDistributorContacts) =>
  useQuery({
    queryKey: ContractorsQueryKeys.getContractorContactsKey(params),
    queryFn: async () => {
      if (!params.contractor_id) return;
      const { items } = await ContractorsApi.fetchContractorContacts({
        contractor_id: params.contractor_id,
        for_distributor_settings: params.for_distributor_settings,
      });

      return items;
    },
    staleTime: Infinity,
    ...queryOptions,
  });
